export default {
	name: "CardConsulta",
	props: [
		'mensagem'
	],
	data() {
		return {
			menuAvaliacao: false,
			loader: false,
			loaderOk: false,
			loaderErro: false,
			notaTemp: 0,
			avaliacao: {
				texto: "",
				nota: 0,
				id: "",
				versao: ""
			},
		}
	},
	mounted() {
		this.getNota()
		
	},computed: {

	},
	methods: {
		urlBase(caminho) {
			var token = this.$root.$store.state.token
			return process.env.VUE_APP_ROOT_API+caminho+'?token='+token
		},
		urlBaseAnexo(caminho) {
			var token = this.$root.$store.state.token
			return process.env.VUE_APP_ROOT_UPLOADS+caminho+'?token='+token
		},
		getNota() {
			//this.notaTemp = this.avaliacao.nota;
			if (this.mensagem.tipo === 'resposta') {
				this.notaTemp = this.mensagem.nota;
				this.avaliacao.nota = this.mensagem.nota;
			}
		},
		enviarAvaliacao() {
			//	let avaliacaoObj = this.avaliacao 
			this.loader = true;
			var token = this.$root.$store.state.token

			var form = new FormData();
			form.append("intAvaliacaoCliente", this.notaTemp);
			form.append("id", this.mensagem.id);
			form.append("strObservacaoAvaliacaoCliente", this.avaliacao.texto);



			this.$root.$api.AvaliarMensagem(form, token).then(response => {
				// console.log('resposta', response)
				if (response ) {
					this.avaliacao.nota = this.notaTemp;
				
					this.loaderOk = true
					this.menuAvaliacao = false;

					setTimeout(() => {
						this.loader = false;
						setTimeout(() => {
							this.loaderOk = false
						}, 1000);
					}, 1500);
				} else {
					this.ativarLoaderErro(response)
				}
			})
		},
		ativarLoaderErro(error) {
			// console.log(error)
			this.loaderErro = true;

			this.menuAvaliacao = false;
			setTimeout(() => {
				this.loader = false;
				setTimeout(() => {
					this.loaderErro = false
				}, 1000);
			}, 1500);
		},
		fecharAvaliacao() {
			this.menuAvaliacao = false;
			this.avaliacao = {
				texto: "",
				nota: 0,
			}
		},
	}
}